var _this = this;
import { processFragments } from './process-fragments';
export var gql = String.raw;
export var graphql = function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var raw = String.raw.apply(_this, args);
  return processFragments(raw);
};